import { showSnackbar } from '../../../api/snackbarSlice';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';

export const deleteProducts = async (payload) => {
  const { data } = await apiClient.delete(`/products/${payload.product_id}`);
  return data;
};

export const useDeleteProductHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteProducts,
    onSuccess: () => {
      dispatch(showSnackbar({ message: 'Product deleted successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const submit = async (data) => {
    mutation.mutate(data);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onDelete: submit,
  };
};
